// 我的相册 API（反编译 com.ulucu.model.http.HttpUrlBuilder）
//
//   POST https://base-service.ulucu.com/picture/printscreen_list
//        body { page, limit }
//   POST https://base-service.ulucu.com/picture/printscreen_del_many
//        body { pic_ids: "12345,67890" }
//
// 响应按日期分组：data: [{ time: "2026/05/08", content: [{ pic_id, pic_path, ... }] }, ...]
import { callInternal } from './internal.js';

/** 反编译 StorePicListEntity.StorePicListItem */
export interface AlbumItem {
	pic_id: string;
	pic_path: string;            // 完整 URL
	capacity?: string;           // 字节数
	channel_id?: string;
	create_time?: string;        // "2026-05-08 14:35:49"
	device_auto_id?: string;
	property_id?: string;
	store_id?: string;
	user_id?: string;
	visit_time?: string;         // 毫秒时间戳
	[k: string]: unknown;
}

/** 按日期分组 */
export interface AlbumGroup {
	time: string;                // "2026/05/08"
	content: AlbumItem[];
}

/** 拉相册列表（按日期分组） */
export async function fetchAlbumList(params: { page?: number; limit?: number } = {}): Promise<AlbumGroup[]> {
	const res = await callInternal<AlbumGroup[]>({
		short_name: 'base',
		action: '/picture/printscreen_list',
		method: 'POST',
		body: {
			page: String(params.page ?? 1),
			limit: String(params.limit ?? 80),
		},
	});
	if (res.code !== 0 || !Array.isArray(res.data)) return [];
	return res.data;
}

/** 删除一组截图（pic_id 数组拼成逗号串） */
export async function deleteAlbumPics(pic_ids: string[]): Promise<boolean> {
	if (pic_ids.length === 0) return true;
	const res = await callInternal({
		short_name: 'base',
		action: '/picture/printscreen_del_many',
		method: 'POST',
		body: { pic_ids: pic_ids.join(',') },
	});
	return res.code === 0;
}
